import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="theme"
export default class extends Controller {
  static targets = ["toggle"]

  initialize() {
    this.setTheme(this.preferredTheme())
  }

  toggle(event) {
    if (event.target.checked) {
      this.setTheme("dark")
    } else {
      this.setTheme("light")
    }
  }

  setTheme(value) {
    this.element.setAttribute('data-bs-theme', value)
    localStorage.setItem('theme', value)
    if (value == "dark") {
      this.toggleTarget.checked = true
    } else {
      this.toggleTarget.checked = false
    }
  }

  storedTheme() {
    return localStorage.getItem('theme')
  }

  preferredTheme() {
    const stored = this.storedTheme()
    if (stored) return stored

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }
}
